export default{
    wsWithTagManager: ["17L9Pvivrdx3R85uAr5H", "sPCGDV1ja9639qzApX3E", "FQXA54XWkOIrdBdULMVk", "GvuEaGezQFTZU5zvpszQ", "UXc4EkcJYjgC6nM2EQAw", "HkJKBo8gOd4e8haQDtBk", "A8fVprrLSKDiXsz065EU", "RUYTHpiiDLQrseFlRJxx", "oQb9bZM5iIB6R6gxfb08", "Y7ZdQzkR9LpvN782zzcX", "tmreVrX2OZ4uOaOq142v", "0Uqr0NjexRCgWKOm30Cu", "jtAO5NriytmXPuHwWH7z"],
    company : 'decode',
    headerStyle : {
        bgColor : '#02F0E4'
    },
    enigmaToogleStyle : {
        bgHeaderOpen : '#88fdf4',
        bgEnigmaOpen : '#e5fefc',
        colorEnigmaClosed : '#ffffff'
    },
    mission : {
        type : 'Trainee',
        name : 'SeLiga na Energisa 2019'
    }
}